export enum AuthFlows {
  WEB = 'web',
  WEBAUTH_DESKTOP = 'webauthdesktop',
  WEBAUTH_MOBILE = 'webauthmobile',
  WEBAUTH_SDK = 'webauthsdk',
}
